const e=async(e,t,n)=>{let{data:r}=await e.get(`/apps/${t}/orgs/${n}`);return r};export{e as getAppAssignment};
//# sourceMappingURL=get-app-assignment.mjs.map